module.exports = __webpack_public_path__ + "img/tab_store.png";